module.exports = __webpack_public_path__ + "img/img52.d0ef5fe9.svg";